import React, { useEffect, useState } from "react";
import { Form, Table } from "react-bootstrap";
import SplitPane from "react-split-pane";
import Pagination from "../../Pagination";
import UseToggle from "../../../Hooks/UseToggle";
import { NoDataFoundTable, PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import { studySubjectManagementServices } from "../../../APIServices/CTMS/SubjectManagement/studySubjectManagementServices";
import { useParams } from "react-router";
import Swal from "sweetalert2";
import Eligiblity from "../../EDCManagement/FormManagement/FormList/Eligiblity";
import ScreeningFail from "../../EDCManagement/FormManagement/FormList/ScreeningFail";
import { studySiteManagementServices } from "../../../APIServices/CTMS/SiteManagement/studySiteManagementServices";
import AddNewSubject from "./AddNewSubject";
import SubjectDetail from "./SubjectDetail";

const SubjectScreening = ({ onMouseDown, tableRef }) => {
  const [subjectColumns, setSubjectColumns] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [subjectListCount, setSubjectListCount] = useState(1);
  const [loading, setLoading] = useState(false);
  const [subjectLoader, setSubjectLoader] = useState(false);
  const [subjectUpdateLoader, setSubjectUpdateLoader] = useState("");
  const [reason, setReason] = useState("");
  const [subjectData, setSubjectData] = useState("");
  const toggles = UseToggle();
  const { studyId } = useParams()
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [siteList, setSiteList] = useState([]);
  const [siteId, setSiteId] = useState("");
  const [subjectSettings, setSubjectSettings] = useState({});
  const [subjectFilters, setSubjectFilters] = useState({
    siteId: "",
    fromDate: "",
    toDate: "",
  });
  const LoginCat = JSON.parse(localStorage.getItem("role")).toLowerCase();
  const eiwrsPermission = JSON.parse(localStorage.getItem("studyPermissionData"));

  const getStudySiteBasedonAccess = async () => {
    let data = await studySiteManagementServices.getStudySiteBasedonAccess(studyId, LoginCat, StudyMode)
    let sites = data?.data || []
    setSiteList(sites)
  }

  const getStudySubjectColumnData = async () => {
    setLoading(true);
    let data = await studySubjectManagementServices.getStudySubjectColumnData(
      "active",
      studyId,
      siteId
    );
    let filterColumn = (data?.data || []).filter(
      (item) =>
        item.blinded === "no"
    );
    setSubjectColumns(filterColumn);
    setLoading(false);
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(subjectListCount / itemsPerPage);

  const getStudySiteSubjectRandomizationData = async () => {
    setSubjectLoader(true)
    let data = await studySubjectManagementServices.getStudySiteSubjectRandomizationData(
      "active",
      studyId,
      "no",
      LoginCat,
      StudyMode,
      pageNumber,
      itemsPerPage,
      subjectFilters
    )
    setSubjectList(data?.data || [])
    setSubjectListCount(data?.count || 0)
    setSubjectLoader(false)
  }

  useEffect(() => {
    getStudySiteSubjectRandomizationData();
  }, [pageNumber, itemsPerPage, subjectFilters]);

  useEffect(() => {
    getStudySiteBasedonAccess();
  }, []);

  useEffect(() => {
    if (siteId) {
      getStudySubjectColumnData();
    }
  }, [siteId]);

  const updateStudySubjectScreen = async (subjectId, siteId, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Subject Eligibility ${status}!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${status === "pass" ? "eligible" : status} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setSubjectUpdateLoader(status)
        let userData = {};
        userData.mode = StudyMode;
        userData.subjectId = subjectId;
        userData.siteId = siteId;
        userData.studyId = studyId;
        userData.screeningStatus = status;
        if (reason) {
          userData.reason = reason;
        }
        let data = await studySubjectManagementServices.updateStudySubjectRowData(userData);
        if (data?.statusCode === 200) {
          getStudySiteSubjectRandomizationData();
          setReason("")
          setSubjectUpdateLoader("")
          if (status === "pass") {
            toggles?.setToggle()
          }
          if (status === "fail") {
            toggles?.setToggle1()
          }
        }
      }
    });
  };

  return (
    <>
      {(StudyMode === "DBP Mode" || eiwrsPermission?.liveManageSubjectScreening || eiwrsPermission?.qcManageSubjectScreening) &&
        <div
          className="justify-content-between toolbar border-bottom hstack p-1"
          style={{ height: 36 }}
        >
          <div className="hstack gap-1">
            <i
              title={"Add Screen New Subject"}
              onClick={() => {
                toggles?.setToggle3();
                setSubjectData("");
                setSiteId("");
              }}
              className={`fa-solid fa-plus-square CP`}
            />
            <div className="vr" />
            <Form.Select
              value={subjectFilters.siteId}
              style={{ width: "150px", padding: "4px 10px" }}
              onChange={(e) => {
                setPageNumber(1);
                setSiteId(e.target.value);
                setSubjectFilters({ ...subjectFilters, siteId: e.target.value });
              }}
            >
              <option value="">Select Site</option>
              {siteList?.map((item, index) => (
                <option key={index} value={item?.row?.SITEID}>
                  {item?.row?.SITEID}
                </option>
              ))}
            </Form.Select>
            <div className="vr" />
            <Form.Label className="m-0">From:</Form.Label> <Form.Control style={{ width: "150px", padding: "4px 10px" }} type="date" value={subjectFilters.fromDate} onChange={(e) => { setPageNumber(1); setSubjectFilters({ ...subjectFilters, fromDate: e.target.value }); }} />
            <Form.Label className="m-0">To:</Form.Label> <Form.Control style={{ width: "150px", padding: "4px 10px" }} type="date" value={subjectFilters.toDate} onChange={(e) => { setPageNumber(1); setSubjectFilters({ ...subjectFilters, toDate: e.target.value }); }} />
          </div>
        </div>
      }
      <SplitPane
        split="vertical"
        minSize={20}
        style={{ height: "calc(100vh - 182px)" }}
        className="position-relative"
        defaultSize={"100%"}
      >
        {subjectLoader ? (
          <PageLoader />
        ) : subjectListCount === 0 ? (
          <NoDataFoundTable MSG={`Data not found!`} />
        ) : subjectList?.length === 0 ? (
          <NoDataFoundTable MSG={`Search Data not found!`} />
        ) : (
          <>
            <Table ref={tableRef} className="m-0 custom-table" hover striped>
              <thead className="position-sticky top-0 z-1">
                <tr>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 0)}
                    style={{ width: 45 }}
                    className="text-center"
                  >
                    Sr.
                  </th>
                  <th onMouseDown={(e) => onMouseDown(e, 1)}>SiteId</th>
                  <th onMouseDown={(e) => onMouseDown(e, 2)}>ScreenId</th>
                  <th onMouseDown={(e) => onMouseDown(e, 3)}>Gender</th>
                  <th onMouseDown={(e) => onMouseDown(e, 4)}>Date of Birth</th>
                  <th onMouseDown={(e) => onMouseDown(e, 5)}>Screening Date</th>
                  <th onMouseDown={(e) => onMouseDown(e, 6)}>Inform Consent Date</th>
                  <th onMouseDown={(e) => onMouseDown(e, 7)}>Screen Status</th>
                  <th className="text-center" onMouseDown={(e) => onMouseDown(e, 8)}>View</th>
                  {(StudyMode === "DBP Mode" || eiwrsPermission?.liveManageSubjectScreening || eiwrsPermission?.qcManageSubjectScreening) &&
                    <th
                      onMouseDown={(e) => onMouseDown(e, 9)}
                      className="text-center"
                      style={{ width: 200 }}
                    >
                      Action
                    </th>
                  }
                </tr>
              </thead>
              <tbody>
                {subjectList?.map((row, index) => (
                  <tr key={index}>
                    <td className="text-center">{index + 1 + startIndex}.</td>
                    <td>{row?.siteName}</td>
                    <td>{row?.row?.SCREENID}</td>
                    <td>{row?.row?.GENDER || "_"}</td>
                    <td>{row?.row?.DOB || "_"}</td>
                    <td>{row?.row?.SCREENINGDATE || "_"}</td>
                    <td>{row?.row?.INFORMCONSENTDATE || "_"}</td>
                    <td className={`fw-bold ${row?.screenStatus === "Pending" ? "text-secondary" : row?.screenStatus === "Failed" ? "text-danger" : "text-success"}`}>{row?.screenStatus}</td>
                    <td className="text-center">
                      <button
                        onClick={(e) => {
                          toggles.setToggle2();
                          setSubjectData(row);
                          setSiteId(row?.siteId);
                          e.stopPropagation();
                        }}
                        className="updateProfile"
                        style={{ padding: "1px 10px" }}
                      >
                        View
                      </button>
                    </td>
                    {(StudyMode === "DBP Mode" || eiwrsPermission?.liveManageSubjectScreening || eiwrsPermission?.qcManageSubjectScreening) &&
                      <td>
                        <div className="hstack gap-3 justify-content-center">
                          <button
                            disabled={row?.screenStatus === "Screened"}
                            onClick={(e) => {
                              toggles.setToggle();
                              setSubjectData(row);
                              e.stopPropagation();
                            }}
                            className="updateProfile"
                            style={{ padding: "1px 10px" }}
                          >
                            Eligible
                          </button>
                          <button
                            disabled={row?.screenStatus === "Failed"}
                            onClick={(e) => {
                              toggles.setToggle1();
                              setSubjectData(row);
                              e.stopPropagation();
                            }}
                            className="removeProfile"
                            style={{ padding: "1px 10px" }}
                          >
                            Screen Fail
                          </button>
                        </div>
                      </td>
                    }
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="position-sticky bottom-0 start-0">
              <Pagination
                totalPage={totalPage}
                pageNumber={pageNumber}
                itemsPerPage={itemsPerPage}
                totalItems={subjectListCount}
                setPageNumber={setPageNumber}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </>
        )}
      </SplitPane>
      <SubjectDetail
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        Show={!toggles?.toggle2}
        Hide={toggles?.setToggle2}
        subjectColumns={subjectColumns}
        subjectData={subjectData}
        loading={loading}
        Title={`View ${subjectData?.row?.SCREENID} ${subjectData?.subjectVoid ? "(VOID)" : ""} Subject  for Site ${subjectData?.siteName}`}
      />
      <AddNewSubject
        Show={!toggles?.toggle3}
        Hide={toggles?.setToggle3}
        siteId={siteId}
        setSiteId={setSiteId}
        siteList={siteList}
        subjectColumns={subjectColumns}
        subjectSettings={subjectSettings}
        setSubjectSettings={setSubjectSettings}
        loading={loading}
        Title={`Add New Subject`}
        getStudySiteSubjectRandomizationData={getStudySiteSubjectRandomizationData}
      />
      <Eligiblity
        Show={!toggles?.toggle}
        Hide={toggles?.setToggle}
        Title={`Check eligibility of ${subjectData?.row?.SCREENID} ${subjectData?.subjectVoid ? "(VOID)" : ""} Subject  for Site ${subjectData?.siteName}`}
        subjectUpdateLoader={subjectUpdateLoader}
        updateStudySubjectScreen={() => updateStudySubjectScreen(subjectData?.subjectId, subjectData?.siteId, "pass")}
      />
      <ScreeningFail
        Show={!toggles?.toggle1}
        Hide={toggles?.setToggle1}
        Title={`Mark ${subjectData?.row?.SCREENID} as failed in screening ${subjectData?.subjectVoid ? "(VOID)" : ""} Subject  for Site ${subjectData?.siteName}`}
        subjectUpdateLoader={subjectUpdateLoader}
        reason={reason}
        setReason={setReason}
        updateStudySubjectScreen={() => updateStudySubjectScreen(subjectData?.subjectId, subjectData?.siteId, "fail")}
      />
    </>
  );
};

export default SubjectScreening;